/**
 * Horizontal drag-to-scroll for Key ingredients (no scrollbar).
 * Mouse/pen: drag. Touch: native swipe.
 */
(function () {
  function bind(el) {
    if (el.dataset.dheDragBound === 'true') return;
    el.dataset.dheDragBound = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.classList.add('is-dragging');
      try {
        el.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    el.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function end() {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
    }

    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('lostpointercapture', end);

    el.addEventListener(
      'click',
      function (e) {
        if (!moved) return;
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('.dhe-pdp-ingredients__scroller').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
